/**
 * @author Rahul Nainala
 * @description 
 */
import React from 'react';
import {
  FormTable,
  FormWithSubTabs,
  FormWithFormSubSectionFormTable,
  FormTableWithMultiSubHedearTable
} from './FormTypes';

const FormTypes = (props) => {
  const { formType } = props;

  switch (formType) {
    case 'FormTable':
      return <FormTable {...props} />;
    case 'FormWithSubTabs':
      return <FormWithSubTabs {...props} />;
    case 'FormWithFormSubSectionFormTable':
      return <FormWithFormSubSectionFormTable {...props} />;
    case 'FormTableWithMultiSubHeaderTable':
      return <FormTableWithMultiSubHedearTable {...props} />;
    default:
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            margin: '50px'
          }}
        >
          {"Form Type doesn't exist"}
        </div>
      );
  }
};

export default FormTypes;
